import React, { useState, forwardRef, useEffect } from 'react'
import { Button, InputGroup, Modal, ModalBody, ModalHeader, Table } from 'reactstrap'
import InputEditor from './InputEditor'
import auth from '../../utils/auth';
import cfg from '../../utils/config';
import axios from 'axios';

const GenericInputFormula = forwardRef(({ value, onChange, isOnFocus, handleFocus, addFormulaTemplate }, ref) => {
    const [modal, setModal] = useState(false);
    const [formulasTemplate, setFormulasTemplate] = useState([]);
    const [limitReached, setLimitReached] = useState(false);

    useEffect(() => {
        getFormulas();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const inputGroup = document.getElementById('formula-input-group')
            const botaoFormula = document.getElementById('btn-formula')
            const jsonTree = document.getElementById('container-campo-customizado')
            const modal = document.getElementById('modal-formula')
            const modalBackdrop = document.getElementsByClassName('modal')[0]

            const clicouNoInput = inputGroup?.contains(event.target)
            const clicouNoBotao = (botaoFormula?.contains(event.target) || botaoFormula === event.target)
            const clicouNoModal = (modal?.contains(event.target) || modalBackdrop === event.target)
            const clicouNaTree = jsonTree?.contains(event.target)

            if (!clicouNoInput && !clicouNaTree && isOnFocus && !clicouNoModal && !clicouNoBotao) {
                handleFocus()
            }
        }

        document.addEventListener('mousedown', handleClickOutside)

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [isOnFocus])

    const getFormulas = async () => {
        try {
            const config_me = {
                headers: {
                    Authorization: 'Bearer ' + auth.getToken()
                }
            };
            const userInfo = auth.getUserInfo();

            const url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + '/formula-template/';

            const res = await axios.get(url, config_me);

            const formulas = res.data.results.map(item => ({
                id: item.id,
                name: `${item.nome}`,
                formula: item.formula,
                description: item.descricao
            }));

            setFormulasTemplate(formulas);

        } catch (error) {
            console.log(error);
        }
    };

    const handleModalFormula = () => {
        setModal(!modal);
    }

    const handleAddFormula = (formula) => {
        handleModalFormula();
        addFormulaTemplate(formula);
    }

    return (
        <div>
            <div className='row' style={{marginRight: 0}}>
                <InputGroup
                    id="formula-input-group"
                    onFocusCapture={(e) => {
                        if (!isOnFocus) {
                            handleFocus()
                        }
                    }}
                    className='col-md-10'
                >
                    <InputEditor ref={ref} value={value} onChange={onChange} onLimitReached={setLimitReached} />
                </InputGroup>
                <Button
                    id="btn-formula"
                    data-tour="param-btn-formulas"
                    color="primary"
                    type="button"
                    onClick={() => {
                        if (!isOnFocus) {
                            handleFocus();
                        }
                        handleModalFormula()
                    }}
                    className="input-formula-btn col-md-2"
                >
                    <span className="formula-btn-icon">√x</span>
                    Fórmulas
                </Button>
            </div>
            {limitReached && (
                <span id='validacao-formula'>
                    Limite de {200} caracteres atingido!
                </span>
            )}
            <Modal id="modal-formula" isOpen={modal} toggle={handleModalFormula} size="lg">
                <ModalHeader toggle={handleModalFormula}>Selecione uma Fórmula</ModalHeader>
                <ModalBody>
                    <Table hover responsive className="afira-table">
                        <thead>
                            <tr>
                                <th>Nome</th>
                                <th>Descrição</th>
                                <th style={{ width: '80px', textAlign: 'center' }}>Adicionar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formulasTemplate.map((formula) => (
                                <tr key={formula.id}>
                                    <td>
                                        {formula.name}
                                    </td>
                                    <td title={formula.description ?? '—'}>
                                        {formula.description ?? '—'}
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        <Button color="success" size="sm" type="button" onClick={() => handleAddFormula(formula.formula)}>
                                            <i className="fa fa-plus"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </ModalBody>
            </Modal>
        </div>
    )
})

export default GenericInputFormula